// employees/actions.js

import {
  getAllEmployees,
  getAllTerminatedEmployees,
} from "../../api/AppDataApi";
import { employeesInitialState } from "./employeesState";

export const makeEmployeesActions = (set, get) => ({
  fetchEmployees: async () => {
    set((s) => ({ employees: { ...s.employees, loading: true, error: null } }));
    try {
      const data = await getAllEmployees();
      set((s) => ({
        employees: { ...s.employees, loading: false, list: data },
      }));
    } catch (err) {
      set((s) => ({
        employees: {
          ...s.employees,
          loading: false,
          error: `Failed to load employees: ${err.message}`,
        },
      }));
      console.error("Employee loading error:", err);
    }
  },
  fetchTerminatedEmployees: async () => {
    set((s) => ({ employees: { ...s.employees, loading: true, error: null } }));
    try {
      const data = await getAllTerminatedEmployees();
      set((s) => ({
        employees: { ...s.employees, loading: false, terminatedList: data },
      }));
    } catch (err) {
      set((s) => ({
        employees: {
          ...s.employees,
          loading: false,
          error: `Failed to load terminated employees: ${err.message}`,
        },
      }));
      console.error("Terminated employee loading error:", err);
    }
  },
  resetTerminatedEmployees: () =>
    set({ employees: { ...employeesInitialState, terminatedList: [] } }),
  resetEmployees: () =>
    set({
      employees: { ...employeesInitialState, list: [], terminatedList: [] },
    }),
});
